import { L as List, d as defineCustomElement$1 } from './p-867a1c3b.js';
const OwcList = List;
const defineCustomElement = defineCustomElement$1;
export { OwcList, defineCustomElement };